// @flow

import {Tag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const SepaTestAccountTable: MarkdocTagRegistration = {
  tag: 'sepa-test-account-table',
  component: 'SepaTestAccountTable',
  render(node, config) {
    const apms = (config.variables.apms: any);
    return new Tag(this.tag, {entries: apms?.sepa_testing_table});
  },
};
